<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <div>
          <material-card
            color="primary"
            title="Homes">
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-btn
              color="general"
              class="mb-2"
              @click="addItem()"
            >New Home</v-btn
            >
            <v-dialog
              v-model="dialogAdd"
              max-width="950px">
              <!-- <template v-slot:activator="{ on }">
                <v-btn color="general" dark class="mb-2" v-on="on"
                  >New Device</v-btn
                >
              </template> -->
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.address"
                          required
                          label="Address (Required)"
                        />
                      </v-flex>

                      <v-flex
                        xs12
                        sm6
                        md4>
                        <!-- <v-text-field
                          v-model="editedItem.device_type"
                          label="Device Type"
                        /> -->
                        <v-select
                          v-model="addedItem.user_email"
                          :items="users"
                          dense
                          required
                          item-text="text"
                          item-value="id"
                          label="User Email (Required)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.name"
                          label="Home Name (Optional)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.home_id"
                          label="Home Id (Auto-generated if not provided)"
                          @keypress="isNumber()"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>

                        <v-autocomplete
                          v-model="addedItem.supply_type"
                          :items="supply_types"
                          dense
                          label="Supply type"
                        />
                      </v-flex>
                      <!-- <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="addedItem.user_email"
                          label="User Email (Optional)"
                        />
                      </v-flex> -->
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeAdd">Cancel</v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="addHome">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogEdit"
              max-width="950px">
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.name"
                          label="Home Name"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.address"
                          label="Address"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.supply_number"
                          label="Supply Number"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>

                        <v-autocomplete
                          v-model="editedItem.supply_type"
                          :items="supply_types"
                          dense
                          label="Supply type"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.email"
                          :items="users"
                          dense
                          label="Email"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeEdit">Cancel</v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="editHome">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogDelete"
              max-width="500px">
              <v-card>
                <v-card-title
                  class="headline"
                >Are you sure you want to delete this home?</v-card-title
                >
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeDelete"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    @click="deleteItemConfirm"
                  >OK</v-btn
                  >
                  <v-spacer/>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="HomeList"
              :search="search"
              class="elevation-1 devices-table"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <!-- <td>{{ props.item.id }}</td> -->
                <td class="">{{ props.item.home_id }}</td>
                <td class="">{{ props.item.name }}</td>
                <!-- <td class="">
                  {{
                    props.item.device_count !== null &&
                    props.item.device_count !== ""
                      ? props.item.device_count
                      : "-"
                  }}
                </td> -->
                <td class="">{{ props.item.address }}</td>
                <td class="">{{ props.item.supply_number }}</td>
                <td class="">{{ props.item.supply_type }}</td>
                <td class="">{{ formatEmail(props.item.email) }}</td>
                <td class="">{{ formatDate(props.item.created_at) }}</td>
                <td class="">{{ formatDeviceList(props.item.devices) }}</td>
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)"
                  >edit</v-icon
                  >
                  <v-icon
                    medium
                    @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="3000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {},
    HomeList: [],
    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [
      10,
      15,
      20,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    dialogAdd: false,
    dialogDelete: false,
    dialogEdit: false,
    search: '',
    headers: [
      { text: 'Id', value: 'id', align: ' d-none' },
      { text: 'Home ID', value: 'home_id' },
      { text: 'Home Name', value: 'name' },
      { text: 'Address', value: 'address' },
      { text: 'Supply Number', value: 'supply_number' },
      { text: 'Supply Type', value: 'supply_type' },
      { text: 'User Email', value: 'email' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Devices', value: 'devices' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    editedIndex: -1,
    deletedIndex: -1,
    deletedItem: {},
    editedItem: {
      name: '',
      email: ''
    },
    addedIndex: -1,
    addedItem: {
      home_id: null,
      address: '',
      user_email: '',
      name: ''
    },
    defaultItem: {},
    deviceTypes: [{ text: 'Single Phase', id: 1 }, { text: 'Three Phase', id: 2 }, { text: 'IAQ', id: 3 }, { text: 'Shelly Plug', id: 4 }, { text: 'Shelly Plug-S', id: 5 }, { text: 'Shelly Motion', id: 6 }, { text: 'Three Phase w/ Relay', id: 7 }],
    projects: [],
    users: [],
    supply_types: [],
  }),

  watch: {
    dialogDelete (val) {
      val || this.closeDelete()
    },
    dialogAdd (val) {
      val || this.closeAdd()
    },
    dialogEdit (val) {
      val || this.closeEdit()
    }
  },
  // called when page is created before dom
  created () {
    this.getHomes()
    this.getProjects()
    this.getUsers()
    this.getSupplyTypes()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    getHomes () {
      this.$http
        .get('homes')
        .then((response) => {
          this.HomeList = response.data
        })
        .catch((error) => console.log(error))
    },

    getProjects () {
      this.$http
        .get('projects')
        .then((response) => {
          var obj = response.data.projects
          this.projects = []
          for (var i = 0; i < obj.length; i++) {
            this.projects.push(obj[i].project)
          }
        })
        .catch((error) => console.log(error))
    },

    getSupplyTypes () {
      this.$http
        .get('homes/supply_types')
        .then((response) => {
          console.log('Response', response.data)
          this.supply_types = response.data
          var obj = response.data
          this.supply_types = []
          for (var i = 0; i < obj.length; i++) {
            this.supply_types.push(obj[i].electrical_supply_types)
          }
        })
        .catch((error) => console.log(error))
    },

    getUsers () {
      this.$http
        .get('admin/users')
        .then((response) => {
          var obj = response.data
          this.users = []
          for (var i = 0; i < obj.length; i++) {
            this.users.push(obj[i].email)
          }
        })
        .catch((error) => console.log(error))
    },

    formatDate (datetime) {
      console.log('Datetime', datetime);
      return moment(datetime).format('MMM DD, YYYY HH:mm:ss')
    },
    formatDeviceList (devices) {
      if(Array.isArray(devices)) {
        return (devices.map((item) => item.deviceId)).join(', ')
      }
      else {
        return '-'
      }
    },
    formatDeviceType (type) {
      let deviceTypeString = 'Single Phase'
      if (type == 1) {
        return 'Single Phase'
      } else if (type == 2) {
        return 'Three Phase'
      }
    },

    formatTags (tags) {
      if (tags !== null) {
        let formattedTags = ''
        for (var i = 0; i < tags.length; i++) {
          formattedTags = formattedTags.concat(tags[i] + ', ')
        }
        formattedTags = formattedTags.replace(/,\s*$/, '')
        return formattedTags
        // return tags.toString();
      } else {
        return '-'
      }
    },

    formatEmail (email) {
      if (email !== null && email !== '') {
        return email
      } else {
        return '-'
      }
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store
        .dispatch('devicesTableActions', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch((error) => {
          console.log(error)
          this.cancelInline
        })
    },

    isNumber (evt) {
      evt = evt || window.event
      let charCode = evt.which || evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
      return false
    },

    validateEmail (inputText) {
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      if (inputText.match(mailformat)) {
        return true
      } else {
        return false
      }
    },

    // ADD

    addItem () {
      this.dialogAdd = true
    },
    addHome () {
      if (
        this.addedItem.address == '' ||
        this.addedItem.address == undefined ||
        this.addedItem.user_email == '' ||
        this.addedItem.user_email == undefined ||
        this.addedItem.name == '' ||
        this.addedItem.name == undefined
      ) {
        this.requiredInline()
      }
      // else if (
      //   this.addedItem.user_email !== "" &&
      //   this.addedItem.user_email !== undefined &&
      //   !this.validateEmail(this.addedItem.user_email)
      // ) {
      //   this.emailErrorInline();
      // }
      else {
        let objectForAddDevice = {}

        if (this.addedItem.home_id !== null) {
          objectForAddDevice.home_id = this.addedItem.home_id
        }

        // objectForAddDevice.device_type =
        //   this.addedItem.deviceTypeSelect == "Single Phase" ? 1 : 2;
        objectForAddDevice.address = this.addedItem.address

        objectForAddDevice.user_email = this.addedItem.user_email
        objectForAddDevice.name = this.addedItem.name
        objectForAddDevice.supply_type = this.addedItem.supply_type

        // if (
        //   this.addedItem.user_email !== "" &&
        //   this.addedItem.user_email !== undefined
        // ) {
        //   objectForAddDevice.user_email = this.addedItem.user_email;
        // }

        let endpoint = `homes`
        let method = 'post'
        let tableItem = objectForAddDevice
        this.$store
          .dispatch('addHome', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getHomes()
          })
          .catch((error) => {
            // console.log(error.response.status);
            this.apiErrorInline()
          })

        this.closeAdd()
      }
    },

    closeAdd () {
      this.dialogAdd = false
      setTimeout(() => {
        this.addedItem = Object.assign({}, this.defaultItem)
        this.addedIndex = -1
      }, 300)
    },

    // DELETE

    deleteItem (item) {
      this.deletedIndex = this.HomeList.indexOf(item)
      this.deletedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      let endpoint = `homes/${this.deletedItem.home_id}`
      let method = 'delete'
      let tableItem = this.deletedItem
      this.$store
        .dispatch('deleteHome', { endpoint, tableItem, method })
        .then((response) => {
          this.HomeList.splice(this.deletedIndex, 1)
          this.saveInline()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeDelete()
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.deletedItem = Object.assign({}, this.defaultItem)
        this.deletedItem = -1
      })
    },

    // EDIT

    editItem (item) {
      this.editedIndex = this.HomeList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogEdit = true
    },

    closeEdit () {
      this.dialogEdit = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem = -1
      })
    },

    editHome () {
      // console.log("editted item: ", this.editedItem);
      // if (
      //   this.editedItem.device_name == "" ||
      //   this.editedItem.device_name == undefined
      // ) {
      //   this.requiredInline();
      // } else {
      let objectForEditDevice = {}
      objectForEditDevice.name = this.editedItem.name

      objectForEditDevice.user_email = this.editedItem.email
      objectForEditDevice.address = this.editedItem.address
      objectForEditDevice.supply_number = this.editedItem.supply_number
      objectForEditDevice.supply_type = this.editedItem.supply_type

      let endpoint = `homes/${this.editedItem.home_id}`
      let method = 'patch'
      let tableItem = objectForEditDevice
      this.$store
        .dispatch('editHome', { endpoint, tableItem, method })
        .then((response) => {
          this.saveInline()
          this.getHomes()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeEdit()
      // }
    },

    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Success'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    apiErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Something went wrong'
    },
    requiredInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Fill all required fields'
    },
    emailErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Enter a valid Email'
    },
    reset () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'heron_info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.devices-table {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
